{
  "content.actions.archive": "归档",
  "content.actions.choose_cover": "选择封面文件",
  "content.actions.publish": "发布",
  "content.actions.unpublish": "撤回发布",
  "content.article.actions.create": "新建文章",
  "content.article.columns.actions": "操作",
  "content.article.columns.featured": "精选",
  "content.article.columns.status": "状态",
  "content.article.columns.title": "文章",
  "content.article.columns.updated": "更新时间",
  "content.article.description": "维护移动端展示的双语文章、分类和发布状态。",
  "content.article.editor.create": "新建文章",
  "content.article.editor.edit": "编辑文章",
  "content.article.empty": "暂无匹配文章",
  "content.article.body_format.blocks": "结构化内容",
  "content.article.body_format.markdown": "Markdown",
  "content.article.fields.body": "正文",
  "content.article.fields.body_format": "正文格式",
  "content.article.fields.category": "分类",
  "content.article.fields.cover": "封面文件",
  "content.article.fields.featured": "精选文章",
  "content.article.fields.reading_minutes": "预计阅读分钟",
  "content.article.fields.slug": "Slug",
  "content.article.fields.sort": "排序值",
  "content.article.fields.status": "状态",
  "content.article.fields.summary": "摘要",
  "content.article.fields.title": "标题",
  "content.article.filters.category": "分类",
  "content.article.filters.landmark": "文章筛选",
  "content.article.filters.q": "搜索文章",
  "content.article.filters.sort": "排序",
  "content.article.filters.status": "状态",
  "content.article.sort.published_at_desc": "最近发布",
  "content.article.sort.sort_order_asc": "排序值",
  "content.article.sort.updated_at_desc": "最近更新",
  "content.article.title": "文章管理",
  "content.category.actions.create": "新建分类",
  "content.category.columns.actions": "操作",
  "content.category.columns.name": "分类",
  "content.category.columns.sort": "排序",
  "content.category.columns.status": "状态",
  "content.category.description": "维护文章分类的双语名称、排序和状态。",
  "content.category.editor.create": "新建分类",
  "content.category.editor.edit": "编辑分类",
  "content.category.empty": "暂无匹配分类",
  "content.category.fields.description": "说明",
  "content.category.fields.name": "名称",
  "content.category.fields.slug": "Slug",
  "content.category.fields.sort": "排序值",
  "content.category.fields.status": "状态",
  "content.category.filters.landmark": "分类筛选",
  "content.category.filters.q": "搜索分类",
  "content.category.filters.status": "状态",
  "content.category.status.active": "启用",
  "content.category.status.disabled": "停用",
  "content.category.title": "分类管理",
  "content.delete.description": "将删除“{name}”，此操作不可撤销。",
  "content.delete.title": "删除此内容？",
  "content.feedback.conflict": "内容已被其他管理员更新，请刷新后再试。",
  "content.feedback.deleted": "内容已删除",
  "content.feedback.load_error": "内容数据加载失败。",
  "content.feedback.published": "文章已发布",
  "content.feedback.save_error": "无法保存内容，请重试。",
  "content.feedback.saved": "内容已保存",
  "content.locales.en-US": "English content",
  "content.locales.zh-CN": "简体中文内容",
  "content.states.refreshing": "正在刷新列表…",
  "content.status.archived": "已归档",
  "content.status.draft": "草稿",
  "content.status.published": "已发布",
  "content.tabs.articles": "文章",
  "content.tabs.categories": "分类",
  "content.validation.invalid": "请检查字段内容。",
  "content.values.no": "否",
  "content.values.none": "未选择",
  "content.values.pending": "待同步",
  "content.values.yes": "是",
  "content.workbench.title": "资讯工作台",
  "content.workbench.description": "统一管理文章、图文、视频、两级分类、专题、标签与评论审核。",
  "content.tabs.topics": "专题",
  "content.tabs.tags": "标签",
  "content.tabs.comments": "评论管理",
  "content.type.article": "文章",
  "content.type.gallery": "图文",
  "content.type.video": "视频",
  "content.article.fields.type": "资讯类型",
  "content.article.fields.categories": "分类（最多 10 个）",
  "content.article.fields.topic": "专题",
  "content.article.fields.tags": "标签（最多 10 个）",
  "content.article.fields.comments": "允许评论",
  "content.article.fields.pinned": "置顶",
  "content.article.fields.latest": "最新",
  "content.article.fields.gallery": "图文图片（1–9 张）",
  "content.article.fields.video_source": "视频来源",
  "content.article.columns.home": "首页属性",
  "content.article.actions.add_image": "添加图片",
  "content.article.actions.add_inline_image": "添加正文插图",
  "content.article.actions.move_up": "上移图片",
  "content.article.actions.move_down": "下移图片",
  "content.article.actions.choose_video": "选择视频文件",
  "content.video_source.upload": "上传文件",
  "content.video_source.external": "HTTPS 外链",
  "content.category.fields.parent": "父分类",
  "content.category.actions.choose_image": "选择分类图片",
  "content.topic.title": "专题管理",
  "content.topic.actions.create": "新建专题",
  "content.topic.actions.choose_cover": "选择专题封面",
  "content.topic.columns.name": "专题",
  "content.topic.editor.edit": "编辑专题",
  "content.topic.fields.name": "专题名称",
  "content.topic.fields.description": "专题描述",
  "content.tag.title": "标签管理",
  "content.tag.fields.name": "输入标签名称，例如 AI",
  "content.tag.columns.name": "标签",
  "content.tag.columns.usage": "引用数",
  "content.tag.actions.disable": "停用",
  "content.tag.actions.enable": "启用",
  "content.tag.actions.merge": "合并到其他标签",
  "content.comment.title": "评论审核",
  "content.comment.columns.author": "用户",
  "content.comment.columns.body": "评论内容",
  "content.comment.columns.status": "状态",
  "content.comment.columns.actions": "审核操作",
  "content.comment.status.pending": "待审核",
  "content.comment.status.approved": "已通过",
  "content.comment.status.rejected": "已拒绝",
  "content.comment.status.hidden": "已隐藏",
  "content.comment.status.deleted": "已删除",
  "content.comment.actions.approve": "通过",
  "content.comment.actions.reject": "拒绝",
  "content.comment.actions.hide": "隐藏",
  "content.comment.actions.batch_approve": "批量通过",
  "content.comment.actions.batch_reject": "批量拒绝",
  "content.comment.reports.title": "评论举报",
  "content.comment.reports.reason": "举报原因",
  "content.comment.reports.details": "补充说明",
  "content.comment.reports.resolve": "处理完成",
  "content.comment.reports.dismiss": "驳回举报",
  "content.comment.reports.dismissed": "举报不成立",
  "content.comment.reasons.policy": "不符合社区规范",
  "content.editor.toolbar": "正文编辑工具栏",
  "content.editor.bold": "粗体",
  "content.editor.italic": "斜体",
  "content.editor.list": "列表",
  "content.editor.quote": "引用",
  "content.editor.code": "代码块",
  "content.article.editor.tabs.meta": "Meta 信息",
  "content.article.editor.tabs.content": "内容",
  "content.article.editor.tabs.commerce": "商品与会员",
  "content.article.preview.cover": "文章封面预览",
  "content.article.fields.video_external_url": "视频外链",
  "content.article.preview.title": "内容预览",
  "content.article.preview.loading": "编辑器加载中...",
  "content.article.actions.menu": "更多",
  "content.article.actions.menu_for": "{name} 的操作",
  "content.tabs.moderation": "评论审核",
  "content.tabs.reports": "举报管理",
  "content.manage.content": "所属内容",
  "content.manage.replyTo": "回复",
  "content.manage.parentUnavailable": "原评论不可见",
  "content.manage.created": "提交时间",
  "content.manage.details": "查看详情",
  "content.manage.reporter": "举报人",
  "content.manage.resolveHide": "成立并隐藏评论",
  "content.manage.search": "搜索评论、内容标题或用户",
  "content.manage.allTypes": "全部内容类型",
  "content.manage.allStatuses": "全部状态",
  "content.manage.allReasons": "全部举报原因",
  "content.manage.recordState": "记录状态",
  "content.manage.live": "未删除",
  "content.manage.dateRange": "提交日期范围",
  "content.manage.article_id": "所属内容 ID",
  "content.manage.author_id": "评论作者 ID",
  "content.manage.reporter_id": "举报人 ID",
  "content.manage.comment_id": "评论 ID",
  "content.manage.reset": "重置筛选",
  "content.manage.refresh": "刷新",
  "content.manage.loadError": "加载失败，请刷新重试",
  "content.manage.invalidId": "请输入有效的 UUID",
  "content.manage.moderationReason": "审核原因",
  "content.manage.moderator": "处理人",
  "content.manage.processedAt": "处理时间",
  "content.manage.resolution": "处理说明",
  "content.manage.reasonRequired": "请填写 1–500 字的处理说明",
  "content.manage.saved": "操作成功，列表已更新",
  "content.manage.actionConfirm": "确认处理",
  "content.manage.deleteConfirm": "确认删除",
  "content.manage.deleteReportHint": "举报将标记为已删除，评论的可见性不会改变。",
  "content.manage.hideHint": "评论将仅作者可见，该评论的其他待处理举报也将结案。",
  "content.manage.confirmHint": "确认处理所选的 {count} 条记录？",
  "content.manage.reportStatus.open": "待处理",
  "content.manage.reportStatus.resolved": "举报成立",
  "content.manage.reportStatus.dismissed": "已驳回",
  "content.manage.reasons.spam": "广告垃圾",
  "content.manage.reasons.abuse": "辱骂骚扰",
  "content.manage.reasons.illegal": "违法违规",
  "content.manage.reasons.privacy": "侵犯隐私",
  "content.manage.reasons.other": "其他",
  "content.manage.liveStatuses": "全部未删除状态",
  "content.manage.findContent": "搜索所属内容",
  "content.article.editor.fullscreen": "全屏编辑",
  "content.article.editor.exit_fullscreen": "退出全屏"
}
